<template>
  <div class="tiles__image-wrap">
    <picture class="tiles__image-picture">
      <source v-for="source in image.sources"
              :media="source.media"
              :sizes="source.sizes"
              :srcset="source.srcset.map(src => `${src.src} ${src.width}w`).join(', ')">
      <img class="tiles__image"
           :src="image.default.src"
           :width="image.default.width"
           :height="image.default.height"
           :alt="image.default.alt ?? image.default.title"
           :title="image.default.title ?? image.default.alt">
    </picture>
  </div>
</template>


<script setup>
/**
 * @typedef {{src: string, width: number, height: number}} SrcSet
 * @typedef {{media: string, sizes: string, srcset: SrcSet[]}} Source
 * @typedef {{default: SrcSet, sources: Source[]}} Image
 */

const props = defineProps({
  /** @type {Image} */
  image: Object,
})

</script>
